import * as React from 'react';
import { useState } from 'react';
import { Col, Row, Form, Nav, Card, Button, ListGroup, Badge, Alert, Modal, Spinner } from "react-bootstrap";
import * as yup from 'yup';
import * as formik from 'formik';
import atlasApi from "../utils/atlasapi";
import schemas from "../data/dataSchemas";
import Select, {components, ControlProps}from "react-select";
import {projectPhaseColors, projectStatusColors} from "../data/ProjectStatusColor";
import {Link} from "@phosphor-icons/react";
import {validity} from  "../utils/functions";

//
//{
//
//    "name":"Latesto O\u00dc",
//    "airtableId":"rec4iQSTveeQTJnJD",
//    "email":"rein.palipea@latesto.ee",
//    "phone":"+3725045647",
//    "address":", ",
//    "id":233,
//    "properties":[
//        {
//            "id":"13402:002:0400",
//            "status":"Ready to sign"
//        }
//    ],
//    "totalArea":6.44
//
//}

const optionStyle = (baseStyles, state) => ({
	...baseStyles, 
	borderRadius:'4px',
	padding:'5px 8px',
	margin: (baseStyles.label == 'singleValue' ? '6px 0px' : '6px 8px'),
	fontSize:'14px',
	lineHeight:'14px',
	color:'white',
	display:'inline-block',
	width:'auto',
	float:'left',
	clear:'both',
	cursor:'pointer',
	backgroundColor: state.data.color,
	color: state.data.textColor
});

const styles = {
	option: optionStyle,
	singleValue : optionStyle,
	valueContainer : (base) => ({
		...base,
		display:'block',
	})
};


const { Formik } = formik;

class DialogProjectSettings extends React.Component {
	
	constructor(props) {
		super(props);
		
		this.state = {
			validated: false,
			status: {sent:null, message:''},
			users:[]
		}

	}
	componentDidUpdate(prevProps){
		if(this.props.state.project && this.props.state.project.projectid != prevProps.state?.project?.projectid){
			this.getUsers(); 
			if(this.props.state.project.projectOwner) {
				this.props.state.project.projectOwnerObj = {
					label: this.props.state.project.projectOwner.name,
					value: this.props.state.project.projectOwner.email
				}
				this.props.state.project.projectOwner = this.props.state.project.projectOwner.email;
			}
		}
	  // code to be executed
	}
	updateStatus(s){
		var x = {...this.state, ...s};
		this.setState(x);
		this.forceUpdate();
	}


	handleClose(data, res){
		this.props.onClose(data, res);
		this.updateStatus({status:{sent:null, message:''}});
	};
	handleOnShow(e){
		
		
		if(!this.props.user.userDetails)
			this.updateStatus({status:{sent:true, success:false, message:'Login required'}});
		this.forceUpdate();
	};

	handleSubmit(data){
		
		this.updateStatus({status:{sent:false, success:false, message:'Saving...'}});
		
		var projectToPost = (({
			name, 
			state, 
			phase,
			projectOwnerObj,
			projectid
		}) => ({ 
			name, 
			state, 
			phase,
			projectOwnerObj,
			projectid
		}))(data);
		
		projectToPost.projectOwner = projectToPost.projectOwnerObj.value;
		

		atlasApi.updateProjectSettings(projectToPost.projectid, projectToPost).then((res)=>{

			this.updateStatus({status:{sent:true, success:true, message:'Project has been saved'}});
		
			projectToPost.projectOwner = {
				name: projectToPost.projectOwnerObj.label,
				email: projectToPost.projectOwnerObj.value 
			}
			
			if(res.success){
				setTimeout(() => {
					this.handleClose(projectToPost, res)
				}, 2000);
			}
			else
				this.updateStatus({status:{sent:true, success:false, message:'Error saving Project'}});
		}).catch((e)=>{
			this.updateStatus({status:{sent:true, success:false, message:'Error saving Project'}});
		});
	};
	
	getUsers(){
		atlasApi.getUsers().then((data)=>{
			this.updateStatus({users:data.map((u)=>{return {label:u.name, value:u.email}})});
		}).catch((e)=>{
			this.updateStatus({status:{sent:true, success:false, message:'Error saving Project'}});
		});
	}


	render() {
		return (
			<Modal show={!!this.props.state.open} onHide={(e)=>this.handleClose(e)} className="project-settings" onShow={(e)=>this.handleOnShow(e)} centered>
				<Modal.Header closeButton>
					<Modal.Title>Edit project settings</Modal.Title>
				</Modal.Header>

				<Formik validationSchema={schemas.projectSettings} onSubmit={this.handleSubmit.bind(this)} initialValues={this.props.state.project}>	
					{({ handleSubmit, handleChange, values, touched, errors, control, setFieldValue }) => (
						
						<Form noValidate onSubmit={handleSubmit}>
							<input type="hidden" name="projectid" value={values.projectid} />
							{this.state.status.sent === null ? (
								<React.Fragment>
									<Modal.Body>
										<Row className="mb-3">
											<Form.Group as={Col} md="12" controlId="validationFormik01">
												<Form.Label>Project Name</Form.Label>
												<Form.Control type="text" name="name" placeholder="Project Name" value={values.name } onChange={handleChange} isValid={touched.name && !errors.name} isInvalid={errors.name}/>
												<Form.Control.Feedback type="invalid">
													Please provide a valid name.
												</Form.Control.Feedback>
											</Form.Group>
										</Row>
										<Row className="mb-3">
											<Form.Group as={Col} md="12" controlId="validationFormik01">
												<Form.Label>State</Form.Label>
												<Select name="state" 
													options={projectStatusColors.asOpts()} 
													onChange={(sel)=>{setFieldValue("state",sel.value)}} 
													defaultValue={projectStatusColors.getOpt(values.state)} 
													isSearchable={false} 
													placeholder="Project state"
													styles={styles}
													className={validity(errors, touched, "state")}
													components={{ IndicatorSeparator: null }}
													
												/>
												<Form.Control.Feedback type="invalid">
													Please provide a valid name.
												</Form.Control.Feedback>
											</Form.Group>
										</Row>
										<Row className="mb-3">
											<Form.Group as={Col} md="12" controlId="validationFormik01">
												<Form.Label>Phase</Form.Label>
												<Select name="phase" 
													options={projectPhaseColors.asOpts()} 
													onChange={(sel)=>{setFieldValue("phase",sel.value)}} 
													defaultValue={projectPhaseColors.getOpt(values.phase)} 
													isSearchable={false} 
													placeholder="Project Phase"
													styles={styles}
													className={validity(errors, touched, "phase")}
													components={{ IndicatorSeparator: null }}
												/>
												<Form.Control.Feedback type="invalid">
													Please provide a valid name.
												</Form.Control.Feedback>
											</Form.Group>
										</Row>
										<Row className="mb-3">
											<Form.Group as={Col} md="12" controlId="validationFormik01">
												<Form.Label>Project owner</Form.Label>
												<Select 
													name="projectOwnerObj" 
													isSearchable={true}
													options={this.state.users} 
													value={values.projectOwnerObj}
													onChange={(sel)=>{setFieldValue("projectOwnerObj",sel)}} 
													placeholder="Project owner"
													className={validity(errors, touched, "projectOwnerObj")}
													components={{ IndicatorSeparator: null }}
												/>
												<Form.Control.Feedback type="invalid">
													Please provide a valid owner.
												</Form.Control.Feedback>
											</Form.Group>
										</Row>
									</Modal.Body>
									<Modal.Footer>
										<Button className="ms-auto" variant="outline-primary" onClick={(e)=>this.handleClose()}>Cancel</Button>
										<Button variant="primary" type="submit">Save settings</Button>
									</Modal.Footer>
								</React.Fragment>
							) : (
							<Modal.Body>
								<Row className="mb-3 dialog-feedback">
									<Col xs="12" className="dialog-feedback-icon text-center">
										{
										this.state.status.sent ?
											(this.state.status.success ? 
												(<i className="ri-checkbox-circle-line text-success"></i>)
												:
												(<i className="ri-error-warning-line text-warning"></i>)
											)
											:
											(<Spinner animation="border" variant="info" className="mt-5" />)
										}
									</Col>
									<Col xs="12" className="dialog-feedback-text mb-5">
										{this.state.status.message}
									</Col>
								</Row>
							</Modal.Body>	
							)}
						</Form>
					)}	
				</Formik>
			</Modal>
		);
	}
}
export default DialogProjectSettings;